export const setActivePuzzle = puzzle => ({
    type: 'SET_ACTIVE_PUZZLE',
    puzzle: puzzle,
});

const initialState = {};

export default (state = initialState, action = {}) => {
    if (action.type === 'SET_ACTIVE_PUZZLE') {
        return action.puzzle;
    } else {
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/activePuzzle.js